import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectAttachedDocumentComponent } from './project-attached-document.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxTooltipModule, DxGalleryModule, DxRadioGroupModule, DxTileViewModule, DxTabPanelModule, DxAccordionModule, DxTextAreaModule, DxNumberBoxModule,DxButtonModule, DxDataGridModule, DxFileUploaderModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxTagBoxModule, DxTextBoxModule, DxCheckBoxModule } from 'devextreme-angular';

@NgModule({
  declarations: [
    ProjectAttachedDocumentComponent
  ],
  imports: [
    CommonModule,
    DxPopupModule,
    DxButtonModule,
    DxTagBoxModule,
    MdbGlobalModule,
    DxTextBoxModule,
    DxGalleryModule,
    DxDataGridModule,
    DxTextAreaModule,
    DxTabPanelModule,
    DxTileViewModule,
    DxNumberBoxModule,
    DxAccordionModule,
    DxSelectBoxModule,
    DxScrollViewModule,
    DxRadioGroupModule,
    DxFileUploaderModule,
    DxTooltipModule,
    DxCheckBoxModule
  ],
  exports: [
    ProjectAttachedDocumentComponent
  ]
})
export class ProjectAttachedDocumentModule { }
